import { createFileRoute } from '@tanstack/react-router';
import { OperationsItemsPage } from '@/features/operations/operations-items-page';
import { operationsGuard } from '@/lib/route-guards';

export const Route = createFileRoute('/operations/items/')({
  beforeLoad: operationsGuard,
  component: OperationsItemsIndexRoute,
});

function OperationsItemsIndexRoute() {
  return <OperationsItemsPage />;
}
